import { Text } from '@/components/shared/components/Text';

export const YES_NO_ARRAY = [
  {
    value: true,
    display: <Text tId={'YES'} />,
  },
  { value: false, display: <Text tId={'NO'} /> },
];
